import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Pencil } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ name: "", image: "", sort_order: 0, meta_title: "", meta_description: "" });
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/categories").then((r) => setCats(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing) await api.put(`/categories/${editing.id}`, form);
      else await api.post("/categories", form);
      toast.success("Saved"); setModal(false); load();
    } catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (c) => { if (!window.confirm(`Delete ${c.name}?`)) return; await api.delete(`/categories/${c.id}`); load(); };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between"><h1 className="text-2xl font-bold">Categories</h1>
        <button data-testid="add-category-btn" onClick={() => { setForm({ name: "", image: "", sort_order: cats.length, meta_title: "", meta_description: "" }); setEditing(null); setModal(true); }} className="px-4 py-2 bg-emerald-600 text-white rounded-lg font-semibold text-sm flex items-center gap-2"><Plus size={16} /> Add Category</button></div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {cats.map((c) => (
          <div key={c.id} data-testid={`admin-category-${c.id}`} className="bg-white rounded-xl border border-slate-200 p-4 flex items-center gap-3">
            <img src={c.image} alt="" className="w-12 h-12 rounded-lg object-cover" />
            <div className="flex-1 min-w-0"><p className="font-semibold text-sm line-clamp-1">{c.name}</p><p className="text-xs text-slate-400">#{c.sort_order}</p></div>
            <button onClick={() => { setForm(c); setEditing(c); setModal(true); }} className="p-1.5 text-slate-500 hover:text-emerald-600"><Pencil size={14} /></button>
            <button onClick={() => del(c)} className="p-1.5 text-slate-500 hover:text-red-500"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
      <Dialog open={modal} onOpenChange={setModal}>
        <DialogContent className="bg-white max-w-sm">
          <DialogHeader><DialogTitle>{editing ? "Edit" : "Add"} Category</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <input data-testid="cat-name" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm" />
            <input data-testid="cat-image" placeholder="Image URL" value={form.image || ""} onChange={(e) => setForm({ ...form, image: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm" />
            <input data-testid="cat-sort" type="number" placeholder="Sort order" value={form.sort_order} onChange={(e) => setForm({ ...form, sort_order: parseInt(e.target.value) || 0 })} className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm" />
            <div className="pt-2 border-t border-slate-100">
              <p className="text-xs font-bold text-slate-500 mb-2">SEO (Google par kaise dikhega)</p>
              <input data-testid="cat-meta-title" placeholder="Meta title (blank = auto)" value={form.meta_title || ""} onChange={(e) => setForm({ ...form, meta_title: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm mb-2" />
              <textarea data-testid="cat-meta-desc" placeholder="Meta description (blank = auto)" value={form.meta_description || ""} onChange={(e) => setForm({ ...form, meta_description: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm h-16" />
            </div>
            <button data-testid="save-category-btn" onClick={save} className="w-full py-2.5 bg-emerald-600 text-white rounded-lg font-bold">Save</button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
